import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Twitter } from 'lucide-react';
import { companyInfo, navigation } from '../data/mock';

const Footer = () => {
  return (
    <footer className="dark-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3 className="footer-title">{companyInfo.name}</h3>
          <p className="footer-tagline">{companyInfo.tagline}</p>
          
          <div className="social-media-links">
            <a href={companyInfo.socialMedia.facebook} target="_blank" rel="noopener noreferrer" className="social-link">
              <Facebook size={20} />
            </a>
            <a href={companyInfo.socialMedia.instagram} target="_blank" rel="noopener noreferrer" className="social-link">
              <Instagram size={20} />
            </a>
            <a href={companyInfo.socialMedia.linkedin} target="_blank" rel="noopener noreferrer" className="social-link">
              <Linkedin size={20} />
            </a>
            <a href={companyInfo.socialMedia.twitter} target="_blank" rel="noopener noreferrer" className="social-link">
              <Twitter size={20} />
            </a>
          </div>
          
          <p className="footer-legal">
            © {new Date().getFullYear()} Quanentry Capital Pvt. Ltd. All rights reserved.
          </p>
        </div>
        
        <div className="footer-section">
          <h4 className="footer-section-title">Quick Links</h4>
          <div className="footer-links">
            {navigation.slice(0, 3).map((item) => (
              <Link key={item.path} to={item.path} className="footer-link">
                {item.label}
              </Link>
            ))}
          </div>
        </div>
        
        <div className="footer-section">
          <h4 className="footer-section-title">Company</h4>
          <div className="footer-links">
            {navigation.slice(3).map((item) => (
              <Link key={item.path} to={item.path} className="footer-link">
                {item.label}
              </Link>
            ))}
          </div>
        </div>
        
        <div className="footer-section">
          <h4 className="footer-section-title">Legal Disclaimer</h4>
          <p className="footer-disclaimer">
            Quanentry Capital Pvt. Ltd. does not accept client funds. All trading is proprietary. No investment advice is provided.
          </p>
          <p className="footer-contact">
            <strong>CIN:</strong> {companyInfo.cin}<br/>
            <strong>Phone:</strong> {companyInfo.phone}<br/>
            <strong>Email:</strong> {companyInfo.email}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
